import { Pipe, PipeTransform } from '@angular/core';

/**
 * @Deprecated:: Use `GoogleDistancePipe` from `@infodata-group/inf-commons-tools` instead.
 */
@Pipe({
  name: 'googleDistance',
})
export class GoogleDistancePipe implements PipeTransform {
  /**
   * distance in meters
   * @param value
   */
  transform(value: number): string {
    if (value < 1000) {
      return `${value} m`;
    }
    return `${(Math.round((value / 1000) * 10) / 10).toString().replace('.', ',')} km`;
  }
}
